/**
 * @generated SignedSource<<559919b3160c43ec51a54e71b603b0a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutSetUpActions_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"checkoutUIActionsTransactionSetup_viewer">;
  readonly " $fragmentType": "checkoutSetUpActions_viewer";
};
export type checkoutSetUpActions_viewer$key = {
  readonly " $data"?: checkoutSetUpActions_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutSetUpActions_viewer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutSetUpActions_viewer"
};

(node as any).hash = "9d4f9f2c59f98c4862cc2730ff95dad6";

export default node;
